<template>
    <div>
        <v-expansion-panels
                v-model="valueOfList"
                multiple
                class="painel-pai"
        >
            <slot></slot>
        </v-expansion-panels>
    </div>
</template>

<script>
  export default {
    name: 'ExpansionPanel',
    props: {
      value: {
        type: Array,
        default () {
          return []
        }
      }
    },
    computed: {
      valueOfList: {
        get () {
          return this.value
        },
        set (newValues) {
          this.$emit('mudarValores', newValues)
          return newValues
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.painel-pai{
  display: flex;
  flex-direction: column;
  background-color: transparent !important;
}
</style>
